{
  "journalAudit.action.document.production_requested": "Document production requested",
  "journalAudit.action.process.gate_approved": "Phase gate acceptance vote recorded"
}
